var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkedin",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.40625C0 2.86818 2.86818 0 6.40625 0H34.5938C38.1318 0 41 2.86818 41 6.40625V34.5938C41 38.1318 38.1318 41 34.5938 41H6.40625C2.86818 41 0 38.1318 0 34.5938V6.40625ZM10.5062 17.0406V30.75H14.8625V17.0406H10.5062ZM10.25 12.6844C10.25 14.0938 11.275 15.1188 12.6844 15.1188C14.0938 15.1188 15.1188 14.0938 15.1188 12.6844C15.1188 11.275 14.0938 10.25 12.6844 10.25C11.4031 10.25 10.25 11.275 10.25 12.6844ZM26.3938 30.75H30.4938V22.2938C30.4938 18.0656 27.9312 16.6562 25.4969 16.6562C23.3187 16.6562 21.7812 18.0656 21.3969 18.9625V17.0406H17.2969V30.75H21.6531V23.4469C21.6531 21.525 22.9344 20.5 24.2156 20.5C25.4969 20.5 26.3938 21.1406 26.3938 23.3187V30.75Z",
    fill: "#00F6EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/LinkedinLogo.386e72389e29a8edfdf4f1671e4647a0.svg";
export { ForwardRef as ReactComponent };